/* import __COLOCATED_TEMPLATE__ from './manual-finish-time-entry-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ManualFinishTimeComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked finishTime = "";
	@tracked plungerTime = "";
	
	@action
	async enterFinishTimeNow()
	{
		const response = await this.ajax.request("/events/"+this.args.event.id+"/enterFinishTime");
		
		if(response.error != null)
			alert(response.error);
	}
	
	@action
	async enterPlungerTimeNow()
	{
		const response = await this.ajax.request("/events/"+this.args.event.id+"/enterPlungerTime");
		
		if(response.error != null)
			alert(response.error);
	}
	
	@action
	async enterFinishTime(browserEvent)
	{
		browserEvent.preventDefault();

		var time = new Date(this.finishTime);

		if(isNaN(time.getTime()))
		{
			alert('Invalid time format. Please enter a valid date/time.');
			return;
		}

		var impulse = this.store.createRecord('TimingImpulse',
		{
			time: time,
		});
		impulse.EventId = this.args.event;

		await impulse.save();

		var iTR = this.store.createRecord('FinishTimingRecord',
		{
		});

		iTR.finishImpulseId = impulse;
		iTR.EventId = this.args.event;

		await iTR.save();
	}
	
	@action
	async enterPlungerTime(browserEvent)
	{
		browserEvent.preventDefault();

		var time = new Date(this.plungerTime);

		if(isNaN(time.getTime()))
		{
			alert('Invalid time format. Please enter a valid date/time.');
			return;
		}

		var impulse = this.store.createRecord('TimingImpulse',
		{
			time: time,
		});
		impulse.EventId = this.args.event;
		await impulse.save()

		var iTR = this.store.createRecord('FinishTimingRecord',
		{
		});
		iTR.finishPlungerImpulseId = impulse;
		iTR.EventId = this.args.event;

		await iTR.save();
	}
}